var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"zv-layout zv-layout-auth"},[(_vm.loading)?_c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.loading),expression:"loading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"loading"}):_vm._e(),_c('el-container',[_c('el-container',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }